import { BULK_OPERATION_CREATE_CONFIG } from "../../../../constant/data";
import { DetailPageTopBarHeading } from "../../../atoms";
import { DetailPageGoToPreviousPageIcon } from "../../../atoms/Icons";
import { useManageMasterContext } from "../../Provider/Manage";
import { Instruction } from "../Instructions";
import { DetailPageTopBarLeft } from "./Left";
import { DetailActionTopBarRight } from "./DetailActionTopBarRight";
import { DetailPageTopBarElement } from "./TopBar.styles";
import { memo } from "react";
import { MasterPushToXeroButton } from "../../../molecules/xero/PushToXeroActions";

/**
 * DetailPageTopBar
 *
 * Memoised container component for a detail‑page top bar; renders its children
 * inside `DetailPageTopBarElement`, with optional element polymorphism via the
 * `as` prop.
 *
 * Props
 * - as (React.ElementType, default "div"): element or component used for the outer wrapper
 * - children (React.ReactNode): elements to render inside the top bar
 * - …rest (HTMLAttributes<HTMLElement>): additional props forwarded to the wrapper
 */

export const DetailPageTopBar = memo(({ as: Element = "div", children, ...rest }) => {
  return (
    <DetailPageTopBarElement as={Element} {...rest}>
      {children}
    </DetailPageTopBarElement>
  );
});

export const CommonMasterTopBar = ({ module, masterRecordId, xeroContactId }) => {
  const { activeStep, isEdit, steps } = useManageMasterContext();
  const { listUrl, verboseName } = BULK_OPERATION_CREATE_CONFIG[module];
  const showXeroPush =
    isEdit && (module === "customer" || module === "supplier") && masterRecordId;

  return (
    <DetailPageTopBar>
      <DetailPageTopBarLeft>
        <DetailPageGoToPreviousPageIcon navigateURL={`/master/${listUrl}/`} />
        <DetailPageTopBarHeading>
          {isEdit ? "Update" : "Create"} {verboseName}
        </DetailPageTopBarHeading>
      </DetailPageTopBarLeft>

      <DetailActionTopBarRight>
        {showXeroPush && (
          <MasterPushToXeroButton
            module={module}
            recordId={masterRecordId}
            xeroContactId={xeroContactId}
          />
        )}
        {activeStep <= steps.length - 1 && <Instruction />}
      </DetailActionTopBarRight>
    </DetailPageTopBar>
  );
};
